import { Provider } from 'react-redux';

import { BasicContent } from './BasicContent';
import RichText from './RichText';
import { CalculatorFiberglass } from '../../ProPink/CalculatorFiberglass';
import { store } from '../../Store';
import Container from '../oc-container';

const CMSFiberglassCalculator = ({ ...content }) => (
  <>
    <BasicContent {...content.copy} />
    <Provider store={store}>
      <Container maxWidth="1170">
        <CalculatorFiberglass />
      </Container>
    </Provider>
    <RichText content={content.footnotes} />
  </>
);

export default CMSFiberglassCalculator;
